var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._b({attrs:{"clearable":_vm.clearable,"size":"mini","filterable":""},on:{"input":function($event){return _vm.$emit('input', $event)}}},'el-select',_vm.$attrs,false),_vm._l((_vm.optionData),function(item,i){return _c('el-option',{key:i+'enumsSelect',attrs:{"label":item[_vm.label],"value":_vm.id==='Object'?item:item[_vm.id]}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }